export default "__VITE_ASSET__BVA4rGAA__"